module.exports = __webpack_public_path__ + "img/mamaroz-logo.ea9ff173.png";